import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';


export type VariantsProps = ApiMethodBase & {}

export const updateTaskAttributes = ({
    eventEmitter,
}: VariantsProps) => {
    eventEmitter.emit(Event.updateTaskAttributes);
};

